var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "领取列表",
        visible: _vm.dialogVisible,
        width: "1100px",
        "close-on-click-modal": false,
        top: "5vh",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "search-area" },
        [
          _c(
            "el-form",
            { attrs: { inline: true, model: _vm.searchForm } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "优惠券名称" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入优惠券名称",
                      clearable: "",
                      size: "small",
                    },
                    model: {
                      value: _vm.searchForm.couponName,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "couponName", $$v)
                      },
                      expression: "searchForm.couponName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "客户名称" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "请输入客户名称",
                      clearable: "",
                      size: "small",
                    },
                    model: {
                      value: _vm.searchForm.shopName,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "shopName", $$v)
                      },
                      expression: "searchForm.shopName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("搜索")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, border: "", height: "600" },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "couponName", label: "优惠券名称" },
          }),
          _c("el-table-column", {
            attrs: { label: "有效时间", width: "220" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      " " +
                        _vm._s(scope.row.effectiveTime) +
                        " 至 " +
                        _vm._s(scope.row.expirationTime) +
                        " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "shopName", label: "客户名称", width: "180" },
          }),
          _c("el-table-column", {
            attrs: { prop: "sendNumber", label: "发券数量", width: "100" },
          }),
          _c("el-table-column", {
            attrs: { prop: "usedNumber", label: "已用", width: "100" },
          }),
          _c("el-table-column", {
            attrs: { prop: "sendShopName", label: "发券人", width: "120" },
          }),
          _c("el-table-column", {
            attrs: { prop: "collectionTime", label: "发券时间", width: "180" },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination" },
        [
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.pagination.current,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.pagination.size,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.pagination.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }